import { supabase } from "@/integrations/supabase/client";

/**
 * After login/signup or when an authenticated user lands on a guarded page,
 * decide whether to send them to onboarding or to the map.
 *
 * Rules (per spec):
 *  - Admins → always /map (bypass onboarding)
 *  - onboarding_completed === false → /onboarding
 *  - Otherwise → /map
 *
 * If the queries fail, fall back to /map so we never trap the user.
 */
export async function getPostAuthDestination(userId: string): Promise<"/map" | "/onboarding"> {
  try {
    const [{ data: isAdmin }, { data: profile }] = await Promise.all([
      supabase.rpc("has_role", { _user_id: userId, _role: "admin" }),
      supabase.from("profiles").select("onboarding_completed").eq("id", userId).maybeSingle(),
    ]);
    if (isAdmin === true) return "/map";
    const completed = (profile as { onboarding_completed?: boolean } | null)?.onboarding_completed;
    return completed ? "/map" : "/onboarding";
  } catch {
    return "/map";
  }
}
